/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "../../../../../shared";
import { useStyles } from "../styles";
import { selectableImageType } from "..";
import NewsImage from "./NewsImage";

interface SelectableImageProps {
  image: selectableImageType;
  selectedImage: selectableImageType | null;
  onImageClick: (image: selectableImageType) => void;
}

const SelectableImage = ({
  image,
  selectedImage,
  onImageClick
}: SelectableImageProps) => {
  const { toSm, toMd, toLg } = useMediaQueries();

  const { selectableImageDiv } = useStyles({
    toMd,
    toSm,
    toLg
  });

  const { imageName } = image;

  return (
    <div
      data-testid="selectable-image"
      css={css([
        selectableImageDiv,
        {
          outline:
            selectedImage?.id === image.id
              ? `2px solid ${colors.blue600}`
              : "unset",
          borderRadius: "8px"
        }
      ])}
      onClick={() => onImageClick(image)}
    >
      <NewsImage
        image={imageName}
        testId={imageName}
        style={{
          height: "100%"
        }}
      />
    </div>
  );
};

export default SelectableImage;
